var angular = require('angular');
const angularRequire = require('../../common/bootstrap/angularRequire');
import accessStore from '../../services/locations/AccessStore'
var reviewBuilderModule = angular.module('clientDashboardApp.reviewBuilder', [

  require('angular-resource'),
  angularRequire('angular-ui-router'),
  require('angular-animate'),
  require('ui-bootstrap4'),
  angularRequire('angular-media-queries'),
  require('angular-sanitize'),
  angularRequire('ui-select'),
  angularRequire('angular-ui-select2'),
  angularRequire('ng-file-upload'),
  angularRequire('angular-filter'),
  angularRequire('angular-ui-ace'),
  'clientDashboardApp.admin',
  'clientDashboardApp.auth',
  'clientDashboardApp.httpUtil'
]);

require('./ReviewGenService')(reviewBuilderModule);
require('./reviewGenCtrl')(reviewBuilderModule);

// Directives
require('./directives/cmNetPromoterScoreDirective').default(reviewBuilderModule);

// Account Config
require('./accountconfig/AccountSettingsModal')(reviewBuilderModule);

// Contact Download
require('./contactdownload/ContactDownloadModal')(reviewBuilderModule);
require('./contactdownload/contactDownloadService')(reviewBuilderModule);

// Campaigns
require('./campaigns/campaignManagerService')
require('./campaigns/CampaignsCtrl').default(reviewBuilderModule);
require('./campaigns/edit/CampaignEditorCtrl')(reviewBuilderModule);
require('./campaigns/deliveryStatusAlertDirective')(reviewBuilderModule);
require('./campaigns/RGSenderConfigService')(reviewBuilderModule);
require('./campaigns/RGSendingStatsService')(reviewBuilderModule);
require('./campaigns/RGSenderConfigModal')(reviewBuilderModule);
require('./campaigns/MessageQuotaWarningConfigModalCtrl')(reviewBuilderModule);
require('./campaigns/campaignLinkModal')

// Contacts
require('./contacts/ContactsCtrl')(reviewBuilderModule);
require('./contacts/edit/ContactEditorCtrl').default(reviewBuilderModule);
require('./contacts/upload/ContactUploadCtrl')(reviewBuilderModule);
require('./contacts/contactDetailModal')(reviewBuilderModule);
require('./contacts/upload/RGContactUploadModalService')(reviewBuilderModule);
require('./contacts/getAddContactsLink');
require('./contacts/statusChart.drv');

// Dashboard
require('./dashboard/revGenDashboardCtrl').default(reviewBuilderModule);

// Reviews
require('./reviews/ReviewsCtrl').default(reviewBuilderModule);
require('./reviews/reviewDetailModal.srv');

// Email Templates
require('./templates/emailTemplates/EmailTemplatesCtrl')(reviewBuilderModule);
require('./templates/emailTemplates/edit/EmailTemplateEditorCtrl')(reviewBuilderModule);
require('./templates/emailTemplates/EmailTemplatesTemplatesCtrl')(reviewBuilderModule);
require('./templates/emailTemplates/emailSelectorDirective');
require('./templates/imageUploader/imageManagerService');
require('./templates/templateDocsViewer');

// Review Forms
require('./templates/reviewForms/ReviewFormsCtrl')(reviewBuilderModule);
require('./templates/reviewForms/edit/ReviewFormEditorCtrl').default(reviewBuilderModule);
require('./templates/reviewForms/ReviewFormTemplatesCtrl')(reviewBuilderModule);
require('./templates/reviewForms/formSelectorDirective');

// Review Forms
require('./templates/imageUploader/imageSelectorDirective');

// Widgets
require('./widgets/edit/widgetEditorCtrl').default(reviewBuilderModule);
require('./widgets/widgetsCtrl').default(reviewBuilderModule);
require('./widgets/widgetTemplatesCtrl')(reviewBuilderModule);
require('./widgets/embed/widgetEmbedDirective')(reviewBuilderModule);

// Visibility Directive
require('./security/visibilityIndicator/visibilityIndicator')

reviewBuilderModule.config(function($stateProvider, adminPageInfoProvider) {

  $stateProvider
    .state('reviewBuilderEntry', {
      url: '/reviewBuilder',
      template: `
        <div class="text-center" style="margin-top: 200px;">
            <i class="fas fa-spinner fa-spin fa-2x"></i>
        </div>
      `,
      onEnter: ['$state', 'reviewGenService', '$timeout', function($state, reviewGenService, $timeout) {
        reviewGenService.listCampaigns().then(campaigns => {
          function getNextState() {
            if (campaigns.length == 0) {
              return ['reviewBuilder.gettingStarted'];
            } else if (false && campaigns.length == 1) {
              // I think we should move to this version later
              // return ['reviewBuilder.campaign.dashboard', {campaignId: campaigns[0]._id.$oid}];
            } else return ['reviewBuilder.campaigns'];
          }
          $timeout(() => // $timeout for what appears to be this issue: https://github.com/angular-ui/ui-router/issues/516
                         // at time of writing, we are using ui-router ~1.0.0-alpha.5 which is from May 12 2016,
                         // so I don't know why the $timeout is still necessary
            $state.go(...getNextState())
          );
        });
      }]
    })
    .state('reviewBuilder', {
      url: '/reviewBuilder',
      abstract: true,
      template: require('./base.html'),
      controller: 'reviewGenCtrl'
    })
    .state('reviewBuilder.campaigns', {
      url: '/campaigns',
      redirectTo: 'reviewBuilder.campaigns.list',
      template: '<ui-view/>'
    })
    .state('reviewBuilder.campaigns.list', {
      url: '',
      template: require('./campaigns/campaigns.html'),
      controller: 'CampaignsCtrl',
      controllerAs: 'vm',
      reloadOnSearch: false,
      resolve: {
        user: (userService) => userService.currentUser(),
        pageInfo: () => adminPageInfoProvider.setIfFirstTimeAppLoad({type: 'campaign', mode: 'manage'})
      },
    })
    .state('reviewBuilder.campaigns.create', {
      url: '/create',
      template: require('./campaigns/edit/campaignEditor.html'),
      controller: 'CampaignEditorCtrl',
      controllerAs: 'vm',
      reloadOnSearch: false,
      params: { mode: 'create' },
      resolve: {
        accountConfiguration: (RGSenderConfigService) => RGSenderConfigService.getConfig(),
        pageInfo: () => adminPageInfoProvider.setIfFirstTimeAppLoad({type: 'campaign', mode: 'create'}),
        campaign: () => null,
        user: (userService) => userService.currentUser(),
        isSharedDefault: (RGSenderConfigService) => {
          return RGSenderConfigService.getConfig().then(config => {
            return config.securityDefaults.areCampaignsShared;
          })
        },
      },
    })
    .state('reviewBuilder.campaign', {
      url: '/campaigns/:campaignId',
      abstract: true,
      views: {
        '@reviewBuilder': {
          template: '<ui-view/>',
          controller: function($scope, campaign) {
            $scope.campaign = campaign;
          }
        }
      },
      resolve: {
        campaign: function(reviewGenService, $stateParams, $state) {
          return reviewGenService.getCampaign($stateParams.campaignId)
            .then(function (resp) {
              return resp
            }, function (error) {
              console.error("Unable to resolve campaign " + $stateParams.campaignId, error);
              $state.go("reviewBuilder.campaigns");
            });
        },
        accountConfiguration: ($stateParams, RGSenderConfigService) => {
          return RGSenderConfigService.getConfigForCampaign($stateParams.campaignId)
        },
        user: (userService) => userService.currentUser()
      }
    })
    .state('reviewBuilder.campaign.dashboard', {
      url: '/dashboard',
      template: require('./dashboard/dashboard.html'),
      controller: 'RevGenDashboardCtrl',
      controllerAs: 'vm',
      reloadOnSearch: false,
      resolve: {
        pageInfo: function () {
          return adminPageInfoProvider.setIfFirstTimeAppLoad({type: 'campaign', mode: 'manage'})
        },
        user: (userService) => userService.currentUser()
      },
    })
    .state('reviewBuilder.gettingStarted', {
      url: '/getting-started',
      template: require('./dashboard/gettingStarted.html'),
      reloadOnSearch: false
    })
    .state('reviewBuilder.campaign.edit', {
      url: '/edit',
      template: require('./campaigns/edit/campaignEditor.html'),
      controller: 'CampaignEditorCtrl',
      controllerAs: 'vm',
      reloadOnSearch: false,
      params: {
        mode: 'edit'
      },
      resolve: {
        accountConfiguration: (RGSenderConfigService) => RGSenderConfigService.getConfig(),
        pageInfo: () => adminPageInfoProvider.setIfFirstTimeAppLoad({type: 'campaign', mode: 'edit'}),
        user: (userService) => userService.currentUser(),
        isSharedDefault: (RGSenderConfigService) => {
          return RGSenderConfigService.getConfig().then(config => {
            return config.securityDefaults.areCampaignsShared;
          })
        },
      },
    })
    .state('reviewBuilder.campaign.reviews', {
      url: "/reviews",
      template: require('./reviews/reviews.html'),
      controller: 'ReviewsCtrl',
      controllerAs: 'vm',
      reloadOnSearch: false,
      resolve: {
        pageInfo: function () {
          return adminPageInfoProvider.setIfFirstTimeAppLoad({type: 'review', mode: 'manage'})
        }
      },
    })


    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     * Contacts section
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
    .state('reviewBuilder.campaign.contacts', {
      url: '/contacts',
      redirectTo: 'reviewBuilder.campaign.contacts.list',
      template: '<ui-view/>'
    })
    .state('reviewBuilder.campaign.contacts.list', {
      url: '',
      template: require('./contacts/contacts.html'),
      controller: 'ContactsCtrl',
      controllerAs: 'vm',
      reloadOnSearch: false,
      resolve: {
        pageInfo: function () {
          return adminPageInfoProvider.setIfFirstTimeAppLoad({type: 'contact', mode: 'manage'})
        }
      },
    })
    .state('reviewBuilder.campaign.contacts.edit', {
      url: '/:contactId/{mode:(?:create|edit)}',
      template: require('./contacts/edit/contactEditor.html'),
      controller: 'ContactEditorCtrl',
      controllerAs: 'vm',
      reloadOnSearch: false,
      resolve: {
        pageInfo: function ($stateParams) {
          return adminPageInfoProvider.setIfFirstTimeAppLoad({type: 'contact', mode: $stateParams.mode})
        },
        locations: function () {
          return accessStore.onceLoaded().then(() => {
            return accessStore.locations.map(x => ({...x, id: x.id.replace("legacy-", "")}))
          })

        }
      },
      params: {
        contact: null,
        contactId: {value: null, squash: true},
        mode: 'edit'
      },
    })

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     * Forms section
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
    .state('reviewBuilder.forms', {
      url: '/reviewForms',
      redirectTo: 'reviewBuilder.forms.list',
      template: '<ui-view/>',
      data: {
        ignoreCampaign: true
      }
    })

    .state('reviewBuilder.forms.list', {
      url: '',
      template: require('./templates/reviewForms/reviewForms.html'),
      controller: 'ReviewFormsCtrl',
      controllerAs: 'vm',
      reloadOnSearch: false,
      resolve: {
        user: (userService) => userService.currentUser(),
        pageInfo: function () {
          return adminPageInfoProvider.setIfFirstTimeAppLoad({type: 'reviewForm', mode: 'manage'})
        }
      },
    })
    .state('reviewBuilder.forms.edit', {
      url: '/:reviewFormId/{mode:(?:edit|create)}/:copy?',
      template: require('./templates/reviewForms/edit/reviewFormEditor.html'),
      controller: 'ReviewFormEditorCtrl',
      controllerAs: 'vm',
      reloadOnSearch: false,
      params: {
        reviewFormId: {value: 'null', squash: true},
        reviewForm: null,
        mode: 'edit',
        copy: {value: null, squash: true}
      },
      resolve: {
        pageInfo: function ($stateParams) {
          return adminPageInfoProvider.setIfFirstTimeAppLoad({type: 'reviewForm', mode: $stateParams.mode})
        },
        onComplete: function($q, $state) {
          let deferred = $q.defer();
          deferred.promise.finally(() => $state.go('^'));
          return deferred;
        },
        isSharedDefault: function(RGSenderConfigService) {
          return RGSenderConfigService.getConfig().then(config => {
            return config.securityDefaults.areFormsShared;
          })
        },
        user: function(userService) { return userService.currentUser() }
      },
    })
    .state('reviewBuilder.forms.templates', {
        url: '/templates',
        template: require('./templates/reviewForms/templates.html'),
        controller: 'ReviewFormTemplatesCtrl',
        controllerAs: 'vm',
        reloadOnSearch: false,
        resolve: {
          pageInfo: function ($stateParams) {
            return adminPageInfoProvider.setIfFirstTimeAppLoad({type: 'reviewForm', mode: $stateParams.mode})
          }
        }
      }
    )

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     * Email templates section
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
    .state('reviewBuilder.emailTemplates', {
      url: '/emailTemplates',
      redirectTo: 'reviewBuilder.emailTemplates.list',
      template: '<ui-view/>',
      data: {
        ignoreCampaign: true
      }
    })
    .state('reviewBuilder.emailTemplates.list', {
      url: '',
      template: require('./templates/emailTemplates/emailTemplates.html'),
      controller: 'EmailTemplatesCtrl',
      controllerAs: 'vm',
      reloadOnSearch: false,
      resolve: {
        user: (userService) => userService.currentUser(),
        pageInfo: function () {
          return adminPageInfoProvider.setIfFirstTimeAppLoad({type: 'emailTemplate', mode: 'manage'})
        }
      },
    })
    .state('reviewBuilder.emailTemplates.edit', {
      url: '/:templateId/{mode:(?:create|edit)}/:copy?',
      template: require('./templates/emailTemplates/edit/emailTemplateEditor.html'),
      controller: 'EmailTemplateEditorCtrl',
      controllerAs: 'vm',
      reloadOnSearch: false,
      resolve: {
        pageInfo: function ($stateParams) {
          return adminPageInfoProvider.setIfFirstTimeAppLoad({type: 'emailTemplate', mode: $stateParams.mode})
        },
        user: (userService) => userService.currentUser(),
        onComplete: function($q, $state) {
          let deferred = $q.defer();
          deferred.promise.finally(() => $state.go('^'));
          return deferred;
        },
        isSharedDefault: function(RGSenderConfigService) {
          return RGSenderConfigService.getConfig().then(config => {
            return config.securityDefaults.areEmailsShared;
          })
        }
      },
      params: {
        mode: 'edit',
        templateId: {value: null, squash: true},
        template: null,
        copy: {value: null, squash: true}
      },
    })
    .state('reviewBuilder.emailTemplates.templates', {
        url: '/templates',
        template: require('./templates/emailTemplates/templates.html'),
        controller: 'EmailTemplatesTemplatesCtrl',
        controllerAs: 'vm',
        reloadOnSearch: false,
        resolve: {
          pageInfo: function ($stateParams) {
            return adminPageInfoProvider.setIfFirstTimeAppLoad({type: 'emailTemplate', mode: $stateParams.mode})
          }
        }
      }
    )

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     * Widgets Section
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

    .state('reviewBuilder.widgets', {
      url: '/widgets',
      redirectTo: 'reviewBuilder.widgets.list',
      template: '<ui-view/>'
    })
    .state('reviewBuilder.widgets.list', {
      url: '',
      template: require('./widgets/widgets.html'),
      controller: 'WidgetsCtrl',
      controllerAs: 'vm',
      reloadOnSearch: false,
      resolve: {
        user: (userService) => userService.currentUser(),
        pageInfo: function () {
          return adminPageInfoProvider.setIfFirstTimeAppLoad({type: 'widget', mode: 'manage'})
        }
      },
    })
    .state('reviewBuilder.widgets.templates', {
        url: '/templates',
        template: require('./widgets/templates.html'),
        controller: 'WidgetTemplatesCtrl',
        controllerAs: 'vm',
        reloadOnSearch: false,
        resolve: {
          pageInfo: function ($stateParams) {
            return adminPageInfoProvider.setIfFirstTimeAppLoad({type: 'widget', mode: $stateParams.mode})
          }
        }
      }
    )
    .state('reviewBuilder.widgets.edit', {
      url: '/:widgetId/{mode:(?:create|edit)}/:copy?',
      template: require('./widgets/edit/widgetEditor.html'),
      controller: 'WidgetEditorCtrl',
      controllerAs: 'vm',
      reloadOnSearch: false,
      resolve: {
        pageInfo: function ($stateParams) {
          return adminPageInfoProvider.setIfFirstTimeAppLoad({type: 'widget', mode: $stateParams.mode})
        },
        isSharedDefault: function(RGSenderConfigService) {
          return RGSenderConfigService.getConfig().then(config => {
            return config.securityDefaults.areWidgetsShared;
          })
        },
        user: function(userService) { return userService.currentUser() }
      },
      params: {
        widgetId: { value: null, squash: true},
        widget: null,
        copy: {value: null, squash: true}
      },
    })
    .state('reviewBuilder.widgets.test', {
      url: '/test',
      template: require('./widgets/testTemplate.html'),
      controller: function($scope,$timeout){
        $scope.aceLoadedHTML = function(_editor){
          $timeout(function(){
            $scope.testHtml = $('.test-html').prop('outerHTML');
          },1)
        }
        $scope.aceChangedHTML = function(e){
          updatePreview();
        }
        $scope.aceLoadedCSS = function(_editor){
          $timeout(function(){
            /*$scope.testCSS = $('.test-css').prop('outerHTML');*/
            initCSS();
          },1)
        }
        $scope.aceChangedCSS = function(e){
          updatePreview();
        }
        function initCSS(){
          var iframe = $("#testTemplate")[0], iframedoc = iframe.contentDocument || iframe.contentWindow.document, d = iframe.document;
          var cssWrapper = '<style type="text/css" rel="stylesheet" id="cssWrapper"></style>';
          $(iframedoc).contents().find("head").append($.parseHTML(cssWrapper));
        }

        function updatePreview(){
          var iframe = $("#testTemplate")[0], iframedoc = iframe.contentDocument || iframe.contentWindow.document, d = iframe.document;
          var cssStr = $scope.testCSS || '';
          $(iframedoc).contents().find("style#cssWrapper").html($.parseHTML(cssStr));
          $(iframedoc).contents().find("body").html($scope.testHtml);
        }
      }
    })


});

